// "YYYY-MM-01" 形式の月文字列を扱うユーティリティ。
// すべてローカル時刻ベースで実装し、toISOString()（UTC変換）は経由しない。
// 内部の月加減算・月初正規化・整形は date-fns に委譲する。
// date-fns もローカル時刻ベースで動作するため、月境界でタイムゾーン分ずれない。
//   - parseISO("2026-07-01") は「日付のみ文字列」をローカル深夜0時として解釈する
//   - format(d, "yyyy-MM-dd") もローカル基準
import { addMonths, startOfMonth, format, parseISO } from "date-fns"

// Date をローカル基準の "YYYY-MM-01"（当月の月初）に整形する。
const toIsoMonth = (d: Date): string => format(startOfMonth(d), "yyyy-MM-01")

// フロントエンドの選択可能月の下限: created_at の月 + 2ヶ月。
// created_at をローカル時刻で解釈して月初に正規化し、+2ヶ月する。
// API のアカウント created_at は "2026/06/25" のスラッシュ形式（strftime "%Y/%m/%d"）で届くが、
// parseISO は ISO 8601（ハイフン）専用のため、ハイフンに正規化してから渡す
export const calcMinMonth = (createdAt: string): string =>
  toIsoMonth(addMonths(parseISO(createdAt.replace(/\//g, "-")), 2))

// "YYYY-MM-01" を日本語ラベル（例: 2024年3月）に変換
export const formatMonthLabel = (isoMonth: string): string => {
  const [year, month] = isoMonth.split("-")
  return `${year}年${parseInt(month)}月`
}
